import c from 'classnames';
import { Plugin } from 'prosemirror-state';
import { findParentNode } from 'prosemirror-utils';
import { Decoration, DecorationSet } from 'prosemirror-view';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import { placeholderPluginKey } from './utils';

export default class Placeholder extends BaseExtension {
  get type(): string {
    return extensionType.toolbar;
  }

  get name(): string {
    return 'placeholder';
  }

  plugins(_editorOptions: EditorOptions) {
    return [
      new Plugin({
        key: placeholderPluginKey,
        state: {
          init() {
            return { placeholders: new Map() };
          },
          apply(tr, old) {
            const props = tr.getMeta(placeholderPluginKey);
            return props || old;
          },
        },
        props: {
          decorations: (state) => {
            const placeholders = placeholderPluginKey.getState(state).placeholders;

            if (!placeholders || !placeholders.size) {
              return;
            }

            const parent = findParentNode((node) => placeholders.has(node.type.name))(
              state.selection,
            );

            if (!parent) {
              return;
            }

            const isEmpty = parent.node.content.size === 0;

            if (isEmpty) {
              const getPlaceholderString = placeholders.get(parent.node.type.name);

              return DecorationSet.create(state.doc, [
                Decoration.node(parent.pos, parent.pos + parent.node.nodeSize, {
                  class: c(
                    'placeholder',
                    //to override deafult placeholder style, use `blockname--placeholder` class
                    parent.node.type.name + '--placeholder',
                  ),
                  'data-placeholder': getPlaceholderString(parent),
                }),
              ]);
            }

            return null;
          },
        },
      }),
    ];
  }
}
